const PREROLL_CHANNEL_TYPES = ['hls-live', 'dash-live']

/**
 * Sets the enablePreRoll and prerollAdSource properties in a safe way
 * Used in both front and back end. Sadly we have to duplicate
 * the code because we cant import form outside src in the FE
 * without ejecting from create-react-app!
 *
 * The stitcher inserts a preroll whenever prerollAdSource is configured and
 * ignores enablePreRoll, so prerollAdSource is cleared when prerolls are disabled.
 *
 * @param {*} channel
 * @param {*} setFrom
 */
module.exports = (channel, setFrom) => {
  setFrom = setFrom || channel
  // has to be explictly boolean or we get "unprocessable entity errors"
  if (PREROLL_CHANNEL_TYPES.includes(channel.type)) {
    channel.enablePreRoll = setFrom.enablePreRoll || false
    channel.prerollAdSource = channel.enablePreRoll ? (setFrom.prerollAdSource || null) : null
  }
}
